@import '~style-sheet-helpers/core.less';
@import '../../../../app-brand/entities/entity-layer.module.less';

.collapsible-list-section {
  border-bottom: 1px solid @collapsable-list--divider-color;
  display: flex;
  flex-direction: column;

  &:first-child {
    flex-shrink: 0;
  }
}
